import { render, staticRenderFns } from "./FullscreenImage.vue?vue&type=template&id=da830152&scoped=true&"
import script from "./FullscreenImage.vue?vue&type=script&lang=js&"
export * from "./FullscreenImage.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenImage.vue?vue&type=style&index=0&id=da830152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da830152",
  null
  
)

export default component.exports